import { useEffect, useRef, useState } from "react";
import { TextField, Typography, Box } from "@mui/material";
import { getIn } from "formik";

// export const FormikEditableText = ({
//   field,
//   form,
//   placeholder = "Double click to edit",
//   variant = "body1",
//   type,
//   ...props
// }) => {
//   const [editing, setEditing] = useState(false);
//   const [localValue, setLocalValue] = useState(field.value ?? "");
//   const inputRef = useRef(null);
//   const previousValue = useRef(field.value);

//   const errorText =
//     getIn(form.touched, field.name) && getIn(form.errors, field.name);

//   useEffect(() => {
//     setLocalValue(field.value ?? "");
//   }, [field.value]);

//   useEffect(() => {
//     if (editing) {
//       previousValue.current = field.value;
//       setTimeout(() => inputRef.current?.focus(), 0);
//     }
//   }, [editing, field.value]);

//   const handleSave = () => {
//     form.setFieldValue(field.name, localValue);
//     setEditing(false);
//   };

//   const handleCancel = () => {
//     setLocalValue(previousValue.current);
//     setEditing(false);
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") handleSave();
//     if (e.key === "Escape") handleCancel();
//   };

//   /** ✅ Allow only numbers */
//   const handleNumberChange = (value) => {
//     if (/^\d*$/.test(value)) {
//       setLocalValue(value);
//     }
//   };

//   return (
//     <Box width="100%">
//       {editing ? (
//         <TextField
//           inputRef={inputRef}
//           value={localValue}
//           type={type}
//           onChange={(e) =>
//             type === "number"
//               ? handleNumberChange(e.target.value)
//               : setLocalValue(e.target.value)
//           }
//           onBlur={handleSave}
//           onKeyDown={handleKeyDown}
//           variant="standard"
//           fullWidth
//           error={!!errorText}
//           helperText={errorText}
//           placeholder={placeholder}
//           sx={{
//             backgroundColor: "#F7FAFF",
//             border: "1px solid #4169E1",
//             borderRadius: "5px",

//             "& .MuiInputBase-input": {
//               padding: "6px 10px",
//               textTransform: props.uppercase ? "uppercase" : "none",
//             },

//             /** ✅ Placeholder fade color */
//             "& input::placeholder": {
//               color: "#94A3B8", // faded slate
//               opacity: 1,
//               fontStyle: "italic",
//             },

//             /** ✅ Remove number arrows */
//             ...(type === "number" && {
//               "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
//                 display: "none",
//               },
//               "& input[type=number]": {
//                 MozAppearance: "textfield",
//               },
//             }),
//           }}
//         />
//       ) : (
//         <Typography
//           onDoubleClick={() => setEditing(true)}
//           variant={variant}
//           sx={{
//             cursor: "pointer",
//             padding: "6px 0px",
//             borderBottom: "1px dashed transparent",
//             color: field.value ? "inherit" : "#94A3B8", // faded when placeholder
//             "&:hover": { borderBottom: "1px dashed #aaa" },
//           }}
//         >
//           {field.value || placeholder}
//         </Typography>
//       )}
//     </Box>
//   );
// };


export const FormikEditableText = ({
  field,
  form,
  placeholder = "Double click to edit",
  variant = "body1",
  type,
  disabled, // 1. Added disabled prop
  value: manualValue, // 2. Added manual value prop
  ...props
}) => {
  const [editing, setEditing] = useState(false);

  // 3. Priority: manualValue > field.value
  const displayValue = manualValue !== undefined ? manualValue : (field.value ?? "");

  const [localValue, setLocalValue] = useState(displayValue);
  const inputRef = useRef(null);
  const previousValue = useRef(displayValue);

  const errorText =
    getIn(form.touched, field.name) && getIn(form.errors, field.name);

  useEffect(() => {
    setLocalValue(displayValue);
  }, [displayValue]);

  useEffect(() => {
    if (editing) {
      previousValue.current = displayValue;
      setTimeout(() => inputRef.current?.focus(), 0);
    }
  }, [editing, displayValue]);

  // const handleSave = () => {
  //   form.setFieldValue(field.name, localValue);
  //   setEditing(false);
  // };

  const handleSave = () => {
    let finalValue = localValue;

    if (type === "number") {
      finalValue =
        localValue === "" || localValue === null
          ? null
          : Number(localValue); 
    }

    form.setFieldValue(field.name, finalValue);
    setEditing(false);
  };


  const handleCancel = () => {
    setLocalValue(previousValue.current);
    setEditing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSave();
    if (e.key === "Escape") handleCancel();
  };

  const handleNumberChange = (val) => {
    if (/^\d*$/.test(val)) {
      setLocalValue(val);
    }
  };

  // 4. Prevention Logic for disabled state
  const handleDoubleClick = () => {
    if (!disabled) {
      setEditing(true);
    }
  };

    useEffect(() => {
    if (manualValue !== undefined) {
      let finalValue = manualValue;

      if (type === "number") {
        finalValue =
          manualValue === "" || manualValue === null
            ? null
            : Number(manualValue);
      }

      form.setFieldValue(field.name, finalValue);
    }
  }, [manualValue]);

  return (
    <Box width="100%">
      {editing ? (
        <TextField
          inputRef={inputRef}
          value={localValue}
          type={type}
          onChange={(e) =>
            type === "number"
              ? handleNumberChange(e.target.value)
              : setLocalValue(e.target.value)
          }
          onBlur={handleSave}
          onKeyDown={handleKeyDown}
          variant="standard"
          fullWidth
          // error={!!errorText}
          // helperText={errorText}
          placeholder={placeholder}
          sx={{
            backgroundColor: "#F7FAFF",
            border: "1px solid #4169E1",
            borderRadius: "5px",
            "& .MuiInputBase-input": {
              padding: "6px 10px",
              textTransform: props.uppercase ? "uppercase" : "none",
            },
            "& input::placeholder": {
              color: "#94A3B8",
              opacity: 1,
              fontStyle: "italic",
            },
            ...(type === "number" && {
              "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
                display: "none",
              },
              "& input[type=number]": {
                MozAppearance: "textfield",
              },
            }),
          }}
        />
      ) : (
        <Typography
          onDoubleClick={handleDoubleClick} // 5. Use the check handler
          variant={variant}
          sx={{
            cursor: disabled ? "default" : "pointer", // 6. Change cursor if disabled
            padding: "6px 0px",
            borderBottom: "1px dashed transparent",
            color: displayValue ? "inherit" : "#94A3B8",
            "&:hover": {
              borderBottom: disabled ? "none" : "1px dashed #aaa"
            },
          }}
        >
          {displayValue || placeholder}
        </Typography>
      )}
      { errorText && 
      <Typography variant="h6" fontSize={"10px"} color="red">{ errorText}</Typography>
      }
             
    
    </Box>
  );
};
